import { getDiscountDisplayData } from './getDiscountDisplayData';

type DiscountDisplayData = ReturnType<typeof getDiscountDisplayData>;

export const getOfferBannerText = (
  discountTerms: DiscountDisplayData,
  show2MonthsPromotion?: boolean,
): string => {
  const { discountTerm, periodOfCover, discountPercentage } = discountTerms;
  const achMarker = discountTerms.discountPaymentType === 'ach' ? '*' : '';

  if (show2MonthsPromotion) {
    return "Our Lowest Price Ever is Back - Don't Miss Out!";
  }

  if (discountPercentage && discountTerm === periodOfCover) {
    return `Online Exclusive Offer - Get ${discountPercentage}% off${achMarker}!`;
  }

  if (discountPercentage && discountTerm && discountTerm < periodOfCover) {
    return `Online Exclusive Offer - Get ${discountPercentage}% off for first ${discountTerm} months${achMarker}!`;
  }

  return 'ONLINE OFFER';
};
